import React from 'react';
import { useAuthContext } from '@isyc-react/auth/modules/context';
import clsx from 'clsx';
export const ImageSmComponent = props => {
  var _user$person$name, _user$person, _user$person$surname, _user$person2;
  const {
    colorIndex,
    disableUserPicture,
    pictureOnClick
  } = props;
  const {
    user
  } = useAuthContext();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('user-picture-zone-sm', {
      'cursor-pointer': pictureOnClick
    }),
    onClick: pictureOnClick
  }, user !== null && user !== void 0 && user.userPicture && user.userPicture.toUpperCase() !== 'NOT_AVAILABLE' && !disableUserPicture ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: user.userPicture,
    alt: "User picture"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `user-picture-letters color-${colorIndex}`
  }, ((_user$person$name = user === null || user === void 0 || (_user$person = user.person) === null || _user$person === void 0 ? void 0 : _user$person.name) !== null && _user$person$name !== void 0 ? _user$person$name : '').charAt(0).toUpperCase(), ((_user$person$surname = user === null || user === void 0 || (_user$person2 = user.person) === null || _user$person2 === void 0 ? void 0 : _user$person2.surname) !== null && _user$person$surname !== void 0 ? _user$person$surname : '').charAt(0).toUpperCase())))));
};
export const ImageLgComponent = props => {
  var _user$person$name2, _user$person3, _user$person$surname2, _user$person4;
  const {
    colorIndex,
    disableUserPicture,
    pictureOnClick
  } = props;
  const {
    user
  } = useAuthContext();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('user-picture-zone-bg', {
      'cursor-pointer': pictureOnClick
    }),
    onClick: pictureOnClick
  }, user !== null && user !== void 0 && user.userPicture && disableUserPicture ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: user.userPicture,
    alt: "User picture"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `user-picture-letters color-${colorIndex}`
  }, ((_user$person$name2 = user === null || user === void 0 || (_user$person3 = user.person) === null || _user$person3 === void 0 ? void 0 : _user$person3.name) !== null && _user$person$name2 !== void 0 ? _user$person$name2 : '').charAt(0).toUpperCase(), ((_user$person$surname2 = user === null || user === void 0 || (_user$person4 = user.person) === null || _user$person4 === void 0 ? void 0 : _user$person4.surname) !== null && _user$person$surname2 !== void 0 ? _user$person$surname2 : '').charAt(0).toUpperCase()))));
};